import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Admission from './pages/Admission';
import Academics from './pages/Academics';
import Contact from './pages/Contact';
import EventDetails from './pages/EventDetails';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/admission" element={<Admission />} />
          <Route path="/academics" element={<Academics />} />
          <Route path="/academics/booklist" element={<Academics />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/event-details/:id" element={<EventDetails />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
